var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "card",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-form",
                {
                  staticClass: "row",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.doFilter($event)
                    }
                  }
                },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("fg-input", [
                        _c(
                          "div",
                          { staticClass: "form-group input-typeahead" },
                          [
                            _c("typeahead", {
                              ref: "userProfileUuidTypeahead",
                              attrs: {
                                customQueryParamName: "name",
                                labelFields: ["name"],
                                placeholder: "Cari Customer",
                                urlSearch: _vm.apiUrlCustomer,
                                "arr-response": "data",
                                model: _vm.tableFilter.customer
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("el-input", {
                        staticClass: "input-primary",
                        attrs: {
                          placeholder: "Filter dengan kode",
                          clearable: ""
                        },
                        model: {
                          value: _vm.tableFilter.kode,
                          callback: function($$v) {
                            _vm.$set(_vm.tableFilter, "kode", $$v)
                          },
                          expression: "tableFilter.kode"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "large",
                            clearable: "",
                            placeholder: "Filter dengan status"
                          },
                          model: {
                            value: _vm.tableFilter.status,
                            callback: function($$v) {
                              _vm.$set(_vm.tableFilter, "status", $$v)
                            },
                            expression: "tableFilter.status"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { value: null, label: "Semua Status" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 0, label: "Pending" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 1, label: "Lunas" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 2, label: "Tahan" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          placeholder: "Pick a range"
                        },
                        model: {
                          value: _vm.tableFilter.date,
                          callback: function($$v) {
                            _vm.$set(_vm.tableFilter, "date", $$v)
                          },
                          expression: "tableFilter.date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { md: "1" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit" }
                      },
                      [_c("font-awesome-icon", { attrs: { icon: "search" } })],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12 text-right" } },
            [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: { click: _vm.doExportToExcel }
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: "download" } }),
                  _vm._v(" Export To Excel\n      ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("paginated-table", {
        ref: "dataTable",
        attrs: {
          "can-delete": false,
          "can-print": true,
          "can-edit": false,
          "param-no-uuid": true,
          "no-actions": true,
          "active-url": _vm.apiUrl,
          "data-url": _vm.apiUrl,
          "data-key": _vm.dataKey,
          "data-columns": _vm.columns,
          "data-params": [
            "is_active",
            "kode",
            "status",
            "start_date",
            "end_date",
            "customer_id"
          ]
        },
        scopedSlots: _vm._u([
          {
            key: "content_created_by",
            fn: function(defaultSlotScope) {
              return [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "#/users/" + defaultSlotScope.rowData.created_by.id
                    }
                  },
                  [_vm._v(_vm._s(defaultSlotScope.rowData.created_by.name))]
                )
              ]
            }
          },
          {
            key: "content_status",
            fn: function(defaultSlotScope) {
              return [
                _c(
                  "b-badge",
                  {
                    attrs: {
                      variant: _vm.getStatusColor(
                        defaultSlotScope.rowData.status
                      )
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.getStatus(defaultSlotScope.rowData.status))
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "content_customer",
            fn: function(defaultSlotScope) {
              return [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "#/pengaturan/customer/" +
                        defaultSlotScope.rowData.customer.id
                    }
                  },
                  [_vm._v(_vm._s(defaultSlotScope.rowData.customer.name))]
                )
              ]
            }
          },
          {
            key: "content_last_updated_by",
            fn: function(defaultSlotScope) {
              return [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "#/users/" + defaultSlotScope.rowData.last_updated_by.id
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(defaultSlotScope.rowData.last_updated_by.name)
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "content_total",
            fn: function(defaultSlotScope) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatNumber(defaultSlotScope.rowData.total)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "content_profit",
            fn: function(defaultSlotScope) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatNumber(defaultSlotScope.rowData.profit)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "content_actions",
            fn: function(defaultSlotScope) {
              return [
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mb-0 text-center detail mr-1",
                        attrs: { variant: "warning", size: "sm" },
                        on: {
                          click: function($event) {
                            _vm.doPrintStruct(defaultSlotScope.rowData.id)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-print" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "mb-0 text-center detail mr-1",
                        attrs: {
                          variant: "info",
                          size: "sm",
                          href: "#/penjualan/" + defaultSlotScope.rowData.id,
                          target: "_blank"
                        }
                      },
                      [_c("i", { staticClass: "fas fa-info" })]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fc35b28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fc35b28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Reports/Index.vue
// module id = 2DeE
// module chunks = 4